export const BUG_CATEGORIES = [
  { value: 'other', label: 'Other' },
  { value: 'ui', label: 'UI / Website' },
  { value: 'match_server', label: 'Match / Server' },
  { value: 'account', label: 'Account / Login' },
  { value: 'payments_shop', label: 'Payments / Shop' },
];

export const BUG_REPORT_MIN_CHARS = 25;
export const BUG_REPORT_MAX_CHARS = 5000;
export const BUG_REPORT_MAX_IMAGES = 5;
export const BUG_REPORT_MAX_BYTES = 2 * 1024 * 1024;

export const BUG_REPORT_ORIGIN_KEY = 'repeaked:bug-report-origin';

const EXCLUDED_ORIGIN_PATHS = new Set(['/report-bug', '/login', '/register', '/auth/callback', '/']);

export function isTrackableBugOrigin(pathname) {
  return pathname && !EXCLUDED_ORIGIN_PATHS.has(pathname) && !pathname.startsWith('/report-bug');
}

export function resolveBugIssuePage(location) {
  const stateOrigin = location?.state?.originPath;
  const storedOrigin = typeof window !== 'undefined'
    ? sessionStorage.getItem(BUG_REPORT_ORIGIN_KEY)
    : null;
  const originPath = (typeof stateOrigin === 'string' && stateOrigin) || storedOrigin || null;

  if (!originPath || !isTrackableBugOrigin(originPath.split('?')[0])) {
    return { originPath: null, issuePageUrl: null };
  }

  return {
    originPath,
    issuePageUrl: `${window.location.origin}${originPath}`,
  };
}
